import script from "./ProductView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductView.vue?vue&type=script&setup=true&lang=js"

import "./ProductView.vue?vue&type=style&index=0&id=3d0fcc0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d0fcc0a"]])

export default __exports__